import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../Home.vue'
import Register from '../components/Register.vue'
import RegisterSuccess from '../components/RegisterSuccess.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/register',
    name: 'RegisterWudi',
    component: Register
  },
  {
    path: '/register-success',
    name: 'RegisterSuccess',
    component: RegisterSuccess
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router